// Use this utility to return true only if not in production.
const nonProductionApiHosts = [
  '.api.luci-dev',
  // '.api.luci-qa',
  // '.api.luci-staging',
];

const isNonProduction =
  process.env.NODE_ENV !== 'production' ||
  nonProductionApiHosts.some((host) =>
    process.env.REACT_APP_SHOPPING_API_BASE_URL?.includes(host)
  );

export default isNonProduction;
